// removed by extract-text-webpack-plugin
module.exports = {"footer":"src-components-Footer----Footer-module---footer---VUGIP","footerRule":"src-components-Footer----Footer-module---footerRule---37sft"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.module.scss
// module id = 267
// module chunks = 221374088121123